// src/utils/shouldShowTutorial.js
import { BLOCKED_TUTORIALS } from "../filterConfig";

export function shouldShowTutorial(tutorial) {
  return !BLOCKED_TUTORIALS.some(
    (block) =>
      tutorial.author === block.author && tutorial.platform === block.platform
  );
}
